import { useTheme } from "@mui/material";
import { PropsWithChildren } from "react";
import { IntercomProvider } from "react-use-intercom";
import { useUser } from "../dataAccess/api/user";
import { IntercomConsumer, SafeIntercomContext } from "./useIntercom";
import { useEditor } from "../wysiwyg/EditorCtx";

export function IntercomWrapper({ children }: PropsWithChildren) {
  const theme = useTheme();
  const { editorParamExist } = useEditor();
  const { user } = useUser();

  if (theme?.settings?.hideSupportChat || editorParamExist) {
    return (
      <SafeIntercomContext.Provider value={null}>
        {children}
      </SafeIntercomContext.Provider>
    );
  }

  return (
    <IntercomProvider
      autoBoot
      appId={process.env.NEXT_PUBLIC_INTERCOM_APP_ID || ""}
      initializeDelay={3500}
      autoBootProps={{
        backgroundColor: theme.palette.primary.main,
        name: user?.firstName ?? "",
        actionColor: theme.palette.primary.main,
      }}
    >
      <IntercomConsumer>{children}</IntercomConsumer>
    </IntercomProvider>
  );
}
